import React, { Component } from "react";
import { connect } from "react-redux";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Sidebar from "./sidebar.component";
import { Redirect } from 'react-router-dom';
import ContentHeader from "./content-header.component";
import { ToastContainer, toast } from 'react-toastify';
import UserService from "../services/user.service";
import axios from "axios";

class PaymentBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            coinDetail: [],
            isLoading: true,
            cointicker: "VSOL",
            pubkey: "",
            fiat_currency: "usd",
            balance: 0
        };
        this.handleClick = this.handleClick.bind(this);
    }

    async componentWillMount() {
        var cointkr = "VSOL";
        await this.loadDetail();

    }

    handleClick = (event) => {
        this.setState({
            loading: true,
        });

        event.preventDefault();
        UserService.Witdrawal(this.state.cointicker).then(
            response => {
                if (response.data.code == 900) {
                    toast.error(response.data.msg);
                    this.setState({
                        loading: false,
                    });
                    return;
                }
                else if (response.data.code == 100) {
                    console.log(response.data.tx)
                    this.setState({
                        txs: (response.data.tx),
                    });
                    const param = { "hex": response.data.tx };

                    //     fetch('https://www.nova-payments.com/api/novawallet/spenttx', {
                    //         method: 'post',
                    //         headers: {'Content-Type':'application/json'},
                    //         body: {
                    //             "hex": response.data.tx
                    //         }
                    //        }).then((res) =>{
                    //            console.log("Responseeeee..");
                    //         console.log(res)
                    //        }).then(async (res) => {
                    //        if (res.status == true) {

                    //        }
                    //        else {
                    //            
                    //        }
                    //    });

                    axios.post("https://www.nova-payments.com/api/novawallet/spenttx", param)
                        .then((response) => {
                            if (response.data.res) 
                            {
                                toast.success("TX Id = " + response.data.txid);
                            }
                            else
                            {
                                toast.error(response.data.txid);
                            }
                            this.setState({
                                loading: false,
                            });
                        });
                }
                else {
                    toast.error(response.data.msg);
                    this.setState({
                        loading: false,
                    });
                }
            },
            error => {
                toast.error("Internal Server Error, please wait..");
                this.setState({
                    loading: false,
                });
                return;
            }
        );
    }




    // handleChange = async (event) => {
    // 	this.setState({
    // 		fiat_currency: event.target.value,
    // 	}, () => {
    // 		this.loadDetail()
    // 			.then(() => {
    // 				this.setState({ isLoading: false })
    // 			})
    // 	})
    // };

    loadDetail = async () => {
        var pubkey = await UserService.getpubkey(this.state.cointicker);
        var objdata = await axios.get("https://www.nova-payments.com/api/novawallet/getxpubbalance/" + pubkey.data.xpub);
        this.setState({
            pubkey: pubkey.data.xpub,
            balance: parseFloat(objdata.data.balance),
            isLoading: false
        })

    }


    render() {
        const { user: currentUser } = this.props;
        if (!currentUser) {
            return <Redirect to="/login" />;
        }

        return (
            <div className="sitemain">
                <Sidebar coin={this.state.cointicker} />
                <main className="main-content">
                    <div className="position-relative">
                        <nav className="nav navbar navbar-expand-lg navbar-light iq-navbar">
                            <div className="container-fluid navbar-inner">
                                <a href="/" className="navbar-brand">
                                    <img src="../assets/images/NOVA-1.png" alt="Nova Wallet" className="logo-img nova-navbar-logo" />
                                </a>
                                <div className="sidebar-toggle" data-toggle="sidebar" data-active="true">
                                    <i className="icon">
                                        <svg width="20px" height="20px" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                                        </svg>
                                    </i>
                                </div>

                                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                    <span className="navbar-toggler-icon">
                                        <span className="navbar-toggler-bar bar1 mt-2"></span>
                                        <span className="navbar-toggler-bar bar2"></span>
                                        <span className="navbar-toggler-bar bar3"></span>
                                    </span>
                                </button>
                                <div className="collapse navbar-collapse" id="navbarSupportedContent">

                                    <ul className="navbar-nav ms-auto align-items-center navbar-list mb-2 mb-lg-0">
                                        <li>
                                            <select className="form-select form-select-sm mb-3 shadow-none" value={this.state.fiat_currency} onChange={this.handleChange}>
                                                <option value="usd">USD</option>
                                                <option value="gbp">GBP</option>
                                                <option value="eur">EUR</option>
                                            </select>
                                        </li>
                                        <li className="nav-item nova-confrmo-nav">
                                            <a href="https://www.confrmo.com" target="_blank" rel="noopener noreferrer" aria-label="Visit Confrmo">
                                                <img src="../assets/images/confrmo.png" alt="Confrmo" />
                                            </a>
                                        </li>
                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href="https://coinmarketcap.com/currencies/vsolidus/" target="_blank" >
                                                <img src="../assets/images/coinmarketcap.png" alt="CoinMarketcap" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
                                            </a>
                                        </li>

                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href="https://www.coingecko.com/en/coins/vsolidus" target="_blank" >
                                                <img src="../assets/images/coingeco.png" alt="CoinGeco" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
                                            </a>
                                        </li>

                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href={'https://www.bitmart.com/trade/en?symbol=VSOL_USDT&layout=basic'} target="_blank" >
                                                <img src="../assets/images/bitmart.png" alt="BitMart" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
                                            </a>
                                        </li>

                                        <li className="nav-item ">
											<a className="nav-link py-0 d-flex align-items-center" href={'https://www.bibox.com/en/exchange/basic/VSOL_USDT'} target="_blank" >
												<img src="../assets/images/bibox.png" alt="BiBox" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
											</a>
										</li>

                                        {/* <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href="https://www.xt.com/tradePro/vsol_usdt" target="_blank" >
                                                <img src="../assets/images/xt.png" alt="XT" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
                                            </a>
                                        </li>

                                        <li className="nav-item ">
                                            <a className="nav-link py-0 d-flex align-items-center" href="https://www.hotbit.io/exchange?symbol=VSOL_USDT" target="_blank" >
                                                <img src="../assets/images/hotbit.png" alt="Hotbit" style={{ width: "50px", height: "50px" }} className="img-fluid avatar avatar-50 avatar-rounded" />
                                            </a>
                                        </li> */}
                                    </ul>
                                </div>
                            </div>
                        </nav>
                        <ContentHeader coin={this.state.cointicker} fiat_currency={this.state.fiat_currency} pagename={"Wallet"} />
                    </div>

                    <div className="conatiner-fluid content-inner mt-n5 py-0">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="d-flex flex-wrap align-items-center justify-content-between">
                                            <div className="d-flex flex-wrap align-items-center">
                                                <div className="profile-img position-relative me-3 mb-3 mb-lg-0 profile-logo profile-logo1">
                                                    <img src={"../../assets/images/coins/" + this.state.cointicker + ".png"} className="img-fluid rounded-pill avatar-100" alt="profile-image" />
                                                </div>
                                                <div className="d-flex flex-wrap align-items-center mb-3 mb-sm-0">
                                                    <h4 className="me-2 h4">Payment Box</h4>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="card">

                                        <div className="card-header">
                                            <h5 className="card-title animated bounceInLeft" data-aos="fade-up" data-aos-delay="400">Payment Box</h5>
                                        </div>

                                        <div className="card-body">
                                            <div className="row">
                                                <div className="form-group col-md-12">
                                                    <div className="input-group my-2">
                                                        <label htmlFor="txtToAddress" className="animated bounceInLeft col-md-12" data-aos="fade-up" data-aos-delay="500"> XPubKey for <a href="https://www.nova-payments.com/" target="_blank">https://www.nova-payments.com</a> </label>
                                                    </div>

                                                    <div className="input-group col-md-9 my-2">
                                                        {/* <label htmlFor="txtxpub" className="animated bounceInLeft" data-aos="fade-up" data-aos-delay="500"> XPubKey </label> */}
                                                        <input className="form-control animated bounceInLeft" id="txtxpub"
                                                            value={this.state.pubkey} data-aos="fade-up" data-aos-delay="500" disabled />
                                                        <div className="input-group-append">
                                                            <CopyToClipboard onCopy={() => toast.warning("Copy to clipboard.")} text={this.state.pubkey}>
                                                                <button className="btn btn-sm btn-primary"><svg width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fillRule="evenodd" clipRule="evenodd" d="M14.7379 2.76175H8.08493C6.00493 2.75375 4.29993 4.41175 4.25093 6.49075V17.2037C4.20493 19.3167 5.87993 21.0677 7.99293 21.1147C8.02393 21.1147 8.05393 21.1157 8.08493 21.1147H16.0739C18.1679 21.0297 19.8179 19.2997 19.8029 17.2037V8.03775L14.7379 2.76175Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                                    <path d="M14.4751 2.75V5.659C14.4751 7.079 15.6231 8.23 17.0431 8.234H19.7981" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                                    <path d="M14.2882 15.3584H8.88818" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                                    <path d="M12.2432 11.606H8.88721" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                                                </svg></button>
                                                            </CopyToClipboard>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group col-md-12">
                                                    <label htmlFor="txtbalance" className="animated bounceInLeft" data-aos="fade-up" data-aos-delay="500">Balance</label>
                                                    <input className="form-control form-control-user animated bounceInLeft" id="txtbalance"
                                                        data-aos="fade-up" data-aos-delay="500" disabled value={this.state.balance} />
                                                </div>

                                            </div>
                                        </div>

                                        {/* <div className="form-group col-md-12">
                                    <label htmlFor="txtToAddress" className="animated bounceInLeft" data-aos="fade-up" data-aos-delay="500">XPubKey </label>
                                    <input className="form-control form-control-user animated bounceInLeft" value={this.state.pubkey} id="txtToAddress" />
                                </div> */}
                                    </div>
                                </div>

                                <div className="col-lg-4">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="d-flex justify-content-between">
                                                <div className="d-flex align-items-center">
                                                    <div className="p-2 rounded bg-warning disabled">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" fill="none" viewBox="0 0 24 24" stroke="white">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
                                                        </svg>
                                                    </div>
                                                    <h4 className="px-3">Withdrawal</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <div className="mt-3  mb-3 text-center text-black-50">
                                                <p>Slate helps you see how many more days you need</p>
                                            </div>
                                            {/*  disabled={this.state.isLoading}  */}

                                            <div className="form-group col-md-12 mt-3 text-center">
                                                <button className="btn btn-primary btn-block" disabled={this.state.isLoading} onClick={this.handleClick}>
                                                    {this.state.isLoading && (
                                                        <span className="spinner-border spinner-border-sm"></span>
                                                    )}
                                                    <span>Withdrawal</span>
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="footer text-center pl-2" >
                        <div className="footer-body">
                            <ul className="left-panel list-inline mb-0 p-0">
                                <li className="list-inline-item"><a href="https://vsolidus.com/copyrightpolicy/" target="_blank">Copyright Policy</a></li>
                                <li className="list-inline-item"><a href="https://vsolidus.com/termsandconditions/" target="_blank">Terms and Conditions</a></li>
                                <li className="list-inline-item"><a href="https://www.vsolidusacademy.com" target="_blank">VSolidus Academy</a></li>
                            </ul>
                            <div className="right-panel">
                                <p>Copyright © <a href="/">Nova Web Wallet</a> 2026</p>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.auth;
    return {
        user,
    };
}

export default connect(mapStateToProps)(PaymentBox);
